import React, { useState, useEffect } from 'react';
import {
  Chip,
  Spinner,
  Button
} from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody
} from "@heroui/modal";
import { useCreatePreview } from '../hooks/useCreatePreview';

const CampaignPreview = ({
    emailValidations,
    cancelPreview,
    cancelForm,
    mailer_content,
    user,
    typos,
    subject,
    tone,
    prompt_inject,
    variability,
    subject_variability,
    vanity_url,
    toRecipients,
    ccRecipients,
    bccRecipients,
    stompClient,
    footer,
    campaign,
    setBanner,
    language
}) => {
  const [loading, setLoading] = useState(true);
  // We set previewSubject and body when we poll and finally get the preview data
  const [body, setBody] = useState();
  const [previewSubject, setPreviewSubject] = useState();
  const previewId = useCreatePreview(subject, mailer_content, tone, variability, subject_variability, campaign, prompt_inject, language);

  const genStompTopicPrefix = () => {
    return window.location.hostname.split('.')[0];
  };

  useEffect(() => {
    stompClient?.subscribe(`/topic/users/${genStompTopicPrefix()}_${user?._id || user?.id}_campaigns`, (message) => handleStompMessage(message));
    // eslint-disable-next-line
  }, [previewId, campaign, mailer_content, subject, tone, variability]);

  const handleStompMessage = async (m) => {
    const message = JSON.parse(m.body);
    console.log("[handleStompMessage]: " + JSON.stringify(message));
    if (message['preview_update'] && previewId && message['preview_update']['campaign_preview_id'] === previewId) {
      if (message['preview_update']['mailer_content']) {
        setBody(message['preview_update']['mailer_content']);
        if (previewSubject) {
          setLoading(false);
        }
      } else if (message['preview_update']['subject']) {
        setPreviewSubject(message['preview_update']['subject']);
        if (body) {
          setLoading(false);
        }
      }
    }
  };

  return (
    <Modal placement='top' size='xl' scrollBehavior='inside' isOpen={true} isDismissable={true}
           isKeyboardDismissDisabled={false} onClose={cancelPreview}>
      <ModalContent>
        <ModalHeader>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <span style={{fontSize: '16px', fontWeight: 'bold'}}>
              Preview of a sample email for:
              <br />
              https://app.ActivistMailer.com/{vanity_url || <i>Not specified yet</i>}
            </span>
          </div>
        </ModalHeader>
        <ModalBody>
          { (loading && (!body && !previewSubject))
            ? <div>
                <div style={{width: '480px', display: 'inline-block'}}>
                  <span style={{paddingLeft: '6px', fontSize: '14px'}}>
                    <i> Processing. This may take a few moments...</i>
                  </span>
                </div>
              </div>
            :
              ''
          }
          <p />
          <div className='helper'>
            <div style={{display: 'flex', flexWrap: 'wrap', alignContent: 'start', padding: '6px', width: '100%'}}>
              <b>To</b>: { toRecipients.map(r => <Chip color={emailValidations && emailValidations.filter(to => to['address'] === r)?.[0]?.['status'] === 'valid' ? 'success' : 'danger'} variant="bordered">{r}</Chip>) }
            </div>

            <div style={{display: 'flex', flexWrap: 'wrap', alignContent: 'start', padding: '6px', width: '100%'}}>
              <b>Cc</b>: { ccRecipients.map(r => <Chip color={emailValidations && emailValidations.filter(cc => cc['address'] === r)?.[0]?.['status'] === 'valid' ? 'success' : 'danger'} variant="bordered">{r}</Chip>) }
            </div>

            <div style={{display: 'flex', flexWrap: 'wrap', alignContent: 'start', padding: '6px', width: '100%'}}>
              <b>Bcc</b>: { bccRecipients.map(r => <Chip color={emailValidations && emailValidations.filter(bcc => bcc['address'] === r)?.[0]?.['status'] === 'valid' ? 'success' : 'danger'} variant="bordered">{r}</Chip>) }
            </div>

          </div>

          <div className='helper'>
            <span><b>Subject</b>: {(previewSubject && previewSubject !== '') ? <pre style={{whiteSpace: 'pre-wrap'}}>{previewSubject}</pre> : <Spinner />}</span>
          </div>

          <div style={{width: '492px', fontSize: 'medium'}}>
            <b>Body</b>: {((body && body !== '') || variability === 0) ? <pre style={{whiteSpace: 'pre-wrap'}}>{variability === 0 ? mailer_content : body}</pre> : <Spinner />}
          </div>
          { (footer && body && body !== '') && <span style={{fontSize: '14px'}}>Mailed with the help of ActivistMailer.com</span> }
          <div style={{margin: '6px'}}>
            <Button style={{marginRight: '8px'}} onPress={cancelPreview} type='submit'>OK</Button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default CampaignPreview;
